import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { baseUrl } from "../../../Components/baseUrl";
import Menu from "../../../Components/Menu";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.css";
import InfiniteScroll from "react-infinite-scroll-component";
import GiftModal from "../../../Components/GiftModal";
import DescriptionModal from "../../../Components/DescriptionModal";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Gallery from "../../../Components/Gallery";
import { CopyToClipboard } from "react-copy-to-clipboard";

const BrandProducts = () => {
    const { compId, brandId } = useParams();
    console.log(compId, brandId);

    const navigate = useNavigate();
    const [filter, setFilter] = useState("");
    let token;
    let user;
    if (typeof window !== "undefined") {
        token = localStorage.getItem("token");
        user = localStorage.getItem("user");
    }
    console.log(user);
    useEffect(() => {
        document.title = "ویزیت | محصولات";
        token == null && navigate(`/login?${compId}`, { replace: true });
    }, []);
    const [showFilter, setShowFilter] = useState(false);
    const [activeMenu, setActiveMenu] = useState(0);
    const [productList, setProductList] = useState([]);
    const [pages, setPages] = useState([]);
    const [numPages, setNumPages] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [cartLoading, setCartLoading] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [loading, setLoading] = useState(true);
    const productHandler = (filt) => {
        let config = {
            url: `${baseUrl}/${compId}/products${
                filt && filt !== undefined
                    ? "?filter=1" + "&orderBy=" + filt + "&brand_id=" + brandId
                    : "?filter=1&brand_id=" + brandId
            }`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                setLoading(false);
                setShowConfirm(false);
                setShowFilter(false);
                setCartLoading(false);
                res &&
                    res.data &&
                    res.data.data &&
                    res.data.data.products &&
                    setProductList(
                        res.data.data.products.map((item) => ({
                            ...item,
                            num: 0,
                        }))
                    );
                res &&
                    res.data &&
                    res.data.data &&
                    res.data.data.paginate &&
                    setPages(res.data.data.paginate);
            })
            .catch((err) => {
                setLoading(false);
                setShowConfirm(false);
                setShowFilter(false);
                setCartLoading(false);
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    useEffect(() => {
        productHandler();
    }, []);
    useEffect(() => {
        let total = pages.totalItems;
        const totalPagesCount = Math.ceil(total / 10);
        setNumPages(
            Array.from({ length: totalPagesCount }, (_, index) => index + 1)
        );
    }, [pages]);
    const [allAmount, setAllAmount] = useState(0);
    const increaseHandler = (item) => {
        const productToUpdate = productList.find((c) => c.id === item.id);
        if (item.max_order) {
            if (
                productToUpdate.num < item.max_order &&
                productToUpdate.num < item.inventory
            ) {
                let i = productList;
                i.find((c) => c.id === item.id).num++;
                setProductList(i);
                setAllAmount(allAmount + Number(item.unit_price));
            } else {
                toast.error("تعداد سفارش بیشتر از حد مجاز.", {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } else {
            if (productToUpdate.num < item.inventory) {
                let i = productList;
                i.find((c) => c.id === item.id).num++;
                setProductList(i);
                setAllAmount(allAmount + Number(item.unit_price));
            } else {
                toast.error("تعداد سفارش بیشتر از حد مجاز.", {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    };
    const decreaseHandler = (item) => {
        let i = productList;
        const foundItem = i.find((c) => c.id === item.id);
        foundItem.num >= 0 && --foundItem.num;
        foundItem.num >= 0 && setAllAmount(allAmount - Number(item.unit_price));
        setProductList(i);
    };
    const [showConfirm, setShowConfirm] = useState(false);
    const addToCartHandler = (e) => {
        setShowConfirm(false);
        setCartLoading(true);
        let items = [];
        let userId = JSON.parse(user).id;
        productList &&
            productList.map((item) => {
                item.num &&
                    item.num !== 0 &&
                    items.push({
                        company_id: compId,
                        product_id: item.id,
                        product_count: item.num,
                    });
            });
        let data = {
            orders: items,
        };
        let config = {
            url: `${baseUrl}/orders`,
            method: "POST",
            data: data,
        };
        axios(config)
            .then((resp) => {
                let config2 = {
                    url: `${baseUrl}/orders/${resp.data.data.order_id}/confirm-cancel?status=confirm`,
                    method: "GET",
                };
                resp.data &&
                    resp.data.data &&
                    axios(config2)
                        .then((res) => {
                            setCartLoading(false);
                            setSearchText("");
                            setAllAmount(0);
                            productHandler();
                            res &&
                                res.data &&
                                res.data.message &&
                                toast.success(
                                    "با موفقیت به سبد خرید اضافه شد",
                                    {
                                        position: "top-center",
                                        autoClose: 5000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                    }
                                );
                        })
                        .catch((err) => {
                            setCartLoading(false);
                            toast.error(err.response.data.message, {
                                position: "top-center",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                        });
            })
            .catch((err) => {
                setCartLoading(false);
                err.response &&
                    err.response.data &&
                    toast.error(err.response.data.message, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
            });
    };

    const pageHandler = () => {
        let config = {
            url: `${baseUrl}/${compId}/products?page=${pages.nextPage}`,
            method: "GET",
        };
        numPages.length >= pages.nextPage &&
            axios(config)
                .then((res) => {
                    res &&
                        res.data &&
                        res.data.data &&
                        res.data.data.products &&
                        setProductList((prevData) => [
                            ...prevData,
                            ...res.data.data.products.map((item) => ({
                                ...item,
                                num: 0,
                            })),
                        ]);
                    res &&
                        res.data &&
                        res.data.data &&
                        res.data.data.paginate &&
                        setPages(res.data.data.paginate);
                })
                .catch((err) => {
                    toast.error(err.response.data.message, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                });
        numPages.length < pages.nextPage && setHasMore(false);
    };

    // Filter
    const [showFilterTab, setShowFilterTab] = useState(0);
    const [showInventory, setShowInventory] = useState(false);
    const [gift, setGift] = useState([]);
    const [showGiftModal, setShowGiftModal] = useState(false);
    const [description, setDescription] = useState([]);
    const [showDescription, setShowDescription] = useState(false);

    // Gallery
    const [showGallery, setShowGallery] = useState(false);
    const [galleryImages, setGalleryImages] = useState([]);

    const openGallery = (images) => {
        setGalleryImages(images);
        setShowGallery(true);
    };

    const closeGallery = () => {
        setShowGallery(false);
    };

    const likeHandler = (id, stts) => {
        let data = new FormData();
        data.append("product_id", id);
        data.append("status", stts == "like" ? 1 : 0);
        let config = {
            method: "POST",
            url: `${baseUrl}/favourite`,
            data: data,
        };
        axios(config)
            .then((response) => {
                productHandler();
            })
            .catch(function (err) {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    const copyHandler = (item) => {
        toast.success("آدرس محصول کپی شد", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    return (
        <div className="container">
            {showGiftModal && <GiftModal gift={gift} />}
            {showDescription && <DescriptionModal description={description} />}
            {showGallery && (
                <Gallery images={galleryImages} onClose={closeGallery} />
            )}
            {showConfirm && (
                <div className="logout-modal">
                    <h2>خروج</h2>
                    <span className="ques">
                        آیا مایلید سفارش فعلی خود را ذخیره کنید؟
                    </span>
                    <div className="btns">
                        <button
                            onClick={() => {
                                addToCartHandler();
                            }}
                            className="stay"
                        >
                            ذخیره
                        </button>
                        <button
                            onClick={() => setShowConfirm(false)}
                            className="exit"
                        >
                            لغو
                        </button>
                    </div>
                </div>
            )}
            {loading ? (
                <div className="emp-main">
                    <img src="/assets/images/loading.gif" width={50} />
                </div>
            ) : productList && productList.length !== 0 ? (
                <div className="product-main">
                    {(activeMenu !== 0 ||
                        showFilter ||
                        showGiftModal ||
                        showDescription) && (
                        <div
                            onClick={() => {
                                setActiveMenu(0);
                                setShowFilter(false);
                                setShowGiftModal(false);
                                setShowDescription(false);
                            }}
                            id="bg_gray"
                            className="bg-gray"
                        ></div>
                    )}
                    {showFilter && (
                        <div id="filter_modal" className="filter-modal">
                            <h2>
                                <svg
                                    onClick={() => {
                                        setShowFilter(false);
                                        allAmount !== 0
                                            ? setShowConfirm(true)
                                            : productHandler();
                                    }}
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M21 7L11 7"
                                        stroke="#3BA7E4"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M7 7C7 8.10457 6.10457 9 5 9C3.89543 9 3 8.10457 3 7C3 5.89543 3.89543 5 5 5"
                                        stroke="#3BA7E4"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        d="M3 17L13 17"
                                        stroke="#3BA7E4"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M17 17C17 18.1046 17.8954 19 19 19C20.1046 19 21 18.1046 21 17C21 15.8954 20.1046 15 19 15"
                                        stroke="#3BA7E4"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                </svg>
                                فیلتر
                            </h2>

                            <button
                                onClick={() => {
                                    setFilter("most_expensive");
                                    productHandler("most_expensive");
                                }}
                                className="mt-5"
                            >
                                گرانترین ها
                            </button>
                            <button
                                onClick={() => {
                                    setFilter("cheapest");
                                    productHandler("cheapest");
                                }}
                                className="mt-3"
                            >
                                ارزانترین ها
                            </button>
                            <button
                                onClick={() => {
                                    setFilter("newest");
                                    productHandler("newest");
                                }}
                                className="mt-3"
                            >
                                جدیدترین ها
                            </button>
                        </div>
                    )}
                    <div className="search-box" id="search_box">
                        <div className="pos-rel-search">
                            <input
                                onChange={(e) => setSearchText(e.target.value)}
                                type="text"
                                value={searchText}
                                placeholder="جستجو کنید"
                            />
                            <svg
                                onClick={() => {
                                    allAmount !== 0
                                        ? setShowConfirm(true)
                                        : productHandler();
                                }}
                                className="search-svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M18.5831 13.5489C19.204 11.7018 19.1293 9.69155 18.3731 7.89557C17.6169 6.09959 16.2312 4.64137 14.4761 3.79465C12.7209 2.94793 10.7171 2.77094 8.84074 3.29691C6.96438 3.82287 5.3445 5.01562 4.28521 6.65125C3.22592 8.28688 2.80005 10.2529 3.08754 12.1803C3.37504 14.1076 4.35614 15.8638 5.84666 17.1191C7.33718 18.3744 9.23463 19.0424 11.1828 18.9979C13.131 18.9534 14.9959 18.1993 16.4275 16.8772"
                                    stroke="#A2A2A2"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M16.5 16.958L21.5 21.958"
                                    stroke="#A2A2A2"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>

                        <div
                            className="svg-rec"
                            onClick={() => setShowFilter(true)}
                        >
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M21 7L11 7"
                                    stroke="#A2A2A2"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M7 7C7 8.10457 6.10457 9 5 9C3.89543 9 3 8.10457 3 7C3 5.89543 3.89543 5 5 5"
                                    stroke="#A2A2A2"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M3 17L13 17"
                                    stroke="#A2A2A2"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M17 17C17 18.1046 17.8954 19 19 19C20.1046 19 21 18.1046 21 17C21 15.8954 20.1046 15 19 15"
                                    stroke="#A2A2A2"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </div>
                    </div>
                    <div className="product-alert">
                        <div className="d-flex-center color-b">
                            <svg
                                width="35"
                                height="35"
                                viewBox="0 0 35 35"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M6.92705 20.373C6.72288 22.7501 8.60412 24.7918 10.9958 24.7918H26.5271C28.6271 24.7918 30.4645 23.071 30.625 20.9855L31.4125 10.048C31.5875 7.62721 29.75 5.65845 27.3145 5.65845H8.48747"
                                    stroke="#e16057"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M2.91663 2.91675H5.45413C7.02913 2.91675 8.26871 4.273 8.13746 5.83341L7.4083 14.6563"
                                    stroke="#e16057"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M23.6979 32.0833C24.7047 32.0833 25.5208 31.2672 25.5208 30.2604C25.5208 29.2536 24.7047 28.4375 23.6979 28.4375C22.6911 28.4375 21.875 29.2536 21.875 30.2604C21.875 31.2672 22.6911 32.0833 23.6979 32.0833Z"
                                    stroke="#e16057"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M12.0313 32.0833C13.0381 32.0833 13.8542 31.2672 13.8542 30.2604C13.8542 29.2536 13.0381 28.4375 12.0313 28.4375C11.0245 28.4375 10.2084 29.2536 10.2084 30.2604C10.2084 31.2672 11.0245 32.0833 12.0313 32.0833Z"
                                    stroke="#e16057"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M13.125 11.6667H30.625"
                                    stroke="#e16057"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            سفارشات جدید
                        </div>
                        <span>{allAmount.toLocaleString()} تومان </span>
                    </div>
                    <InfiniteScroll
                        dataLength={productList.length}
                        next={pageHandler}
                        hasMore={hasMore}
                        loader={
                            productList.length !== 0 && (
                                <div className="mx-auto d-flex justify-content-center mt-4">
                                    <img
                                        src="/assets/images/loading.gif"
                                        width={40}
                                    />
                                </div>
                            )
                        }
                    >
                        {productList !== undefined &&
                            productList !== null &&
                            productList.length !== 0 &&
                            productList.map((item) => {
                                return (
                                    <div key={item.id} className="product-card">
                                        <div className="row-1">
                                            <div className="img-div">
                                                {item.Images &&
                                                item.Images[0] ? (
                                                    <div
                                                        className="img-div"
                                                        onClick={() =>
                                                            openGallery(
                                                                item.Images
                                                            )
                                                        }
                                                    >
                                                        <img
                                                            src={
                                                                item.Images[0]
                                                                    .image
                                                            }
                                                            alt=""
                                                        />
                                                    </div>
                                                ) : (
                                                    <div className="img-div">
                                                        <img
                                                            src={item.Images}
                                                            alt=""
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                            <div className="like-div">
                                                {!item.is_favourite ? (
                                                    <svg
                                                        onClick={() => {
                                                            likeHandler(
                                                                item.id,
                                                                "like"
                                                            );
                                                        }}
                                                        className="no-like"
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M17.1999 21.9999C19.8509 21.9999 21.9999 19.8509 21.9999 17.1999C21.9999 14.5489 19.8509 12.3999 17.1999 12.3999C14.5489 12.3999 12.3999 14.5489 12.3999 17.1999C12.3999 19.8509 14.5489 21.9999 17.1999 21.9999Z"
                                                            stroke="#292D32"
                                                            strokeWidth="1.5"
                                                            strokeMiterlimit="10"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M18.9899 17.2598H15.4099"
                                                            stroke="#292D32"
                                                            strokeWidth="1.5"
                                                            strokeMiterlimit="10"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M17.2 15.5098V19.0997"
                                                            stroke="#292D32"
                                                            strokeWidth="1.5"
                                                            strokeMiterlimit="10"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            opacity="0.4"
                                                            d="M22 8.69012C22 10.6601 21.49 12.4001 20.69 13.9101C19.81 12.9801 18.57 12.4001 17.2 12.4001C14.55 12.4001 12.4 14.5501 12.4 17.2001C12.4 18.4301 12.87 19.5501 13.63 20.4001C13.26 20.5701 12.92 20.7101 12.62 20.8101C12.28 20.9301 11.72 20.9301 11.38 20.8101C8.48 19.8201 2 15.6901 2 8.69012C2 5.60012 4.49 3.1001 7.56 3.1001C9.37 3.1001 10.99 3.98014 12 5.33014C13.01 3.98014 14.63 3.1001 16.44 3.1001C19.51 3.1001 22 5.60012 22 8.69012Z"
                                                            stroke="#292D32"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                ) : (
                                                    <svg
                                                        onClick={() => {
                                                            likeHandler(
                                                                item.id,
                                                                "des"
                                                            );
                                                        }}
                                                        className="no-like"
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M12.62 20.8101C12.28 20.9301 11.72 20.9301 11.38 20.8101C8.48 19.8201 2 15.6901 2 8.6901C2 5.6001 4.49 3.1001 7.56 3.1001C9.38 3.1001 10.99 3.9801 12 5.3401C13.01 3.9801 14.63 3.1001 16.44 3.1001C19.51 3.1001 22 5.6001 22 8.6901C22 15.6901 15.52 19.8201 12.62 20.8101Z"
                                                            fill="#FF0000"
                                                        />
                                                    </svg>
                                                )}
                                            </div>
                                            <div>
                                                <div className="marquee">
                                                    <h4
                                                        className={
                                                            item.name.length <
                                                            13
                                                                ? "name"
                                                                : item.name
                                                                      .length <
                                                                  25
                                                                ? "name moving-2"
                                                                : "name moving"
                                                        }
                                                    >
                                                        <span>{item.name}</span>
                                                    </h4>
                                                </div>
                                                <div className="d-flex-center">
                                                    <span className="price-span-1">
                                                        قیمت واحد:
                                                    </span>
                                                    <span className="price-span-2">
                                                        {Number(
                                                            item.unit_price
                                                        ).toLocaleString()}{" "}
                                                        تومان
                                                    </span>
                                                </div>
                                                <div className="d-flex-center">
                                                    <span className="muted-span-1">
                                                        قیمت فروشگاه:
                                                    </span>
                                                    <span className="muted-span-2">
                                                        {Number(
                                                            item.store_price
                                                        ).toLocaleString()}{" "}
                                                        تومان
                                                    </span>
                                                </div>
                                                <div className="d-flex-center">
                                                    <span className="muted-span-1">
                                                        قیمت مصرف کننده:
                                                    </span>
                                                    <span className="muted-span-2">
                                                        {Number(
                                                            item.consumer_price
                                                        ).toLocaleString()}{" "}
                                                        تومان
                                                    </span>
                                                </div>
                                                <div className="d-flex-center">
                                                    <span className="muted-span-1">
                                                        تعداد در واحد:
                                                    </span>
                                                    <span className="muted-span-2">
                                                        {item.unit_count}{" "}
                                                        {item.measure_unit.name}
                                                    </span>
                                                </div>
                                            </div>
                                            <div
                                                className="gift"
                                                onClick={() => {
                                                    setGift(item.Gifts);
                                                    setShowGiftModal(true);
                                                }}
                                            >
                                                <svg
                                                    width="18"
                                                    height="18"
                                                    viewBox="0 0 18 18"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M14.9775 7.5H2.97754V13.5C2.97754 15.75 3.72754 16.5 5.97754 16.5H11.9775C14.2275 16.5 14.9775 15.75 14.9775 13.5V7.5Z"
                                                        stroke="#3BA7E4"
                                                        strokeWidth="1.5"
                                                        strokeMiterlimit="10"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M16.125 5.25V6C16.125 6.825 15.7275 7.5 14.625 7.5H3.375C2.2275 7.5 1.875 6.825 1.875 6V5.25C1.875 4.425 2.2275 3.75 3.375 3.75H14.625C15.7275 3.75 16.125 4.425 16.125 5.25Z"
                                                        stroke="#3BA7E4"
                                                        strokeWidth="1.5"
                                                        strokeMiterlimit="10"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        opacity="0.4"
                                                        d="M8.73008 3.75008H4.59008C4.33508 3.47258 4.34258 3.04508 4.61258 2.77508L5.67758 1.71008C5.95508 1.43258 6.41258 1.43258 6.69008 1.71008L8.73008 3.75008Z"
                                                        stroke="#3BA7E4"
                                                        strokeWidth="1.5"
                                                        strokeMiterlimit="10"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        opacity="0.4"
                                                        d="M13.4025 3.75008H9.26245L11.3025 1.71008C11.58 1.43258 12.0375 1.43258 12.315 1.71008L13.38 2.77508C13.65 3.04508 13.6575 3.47258 13.4025 3.75008Z"
                                                        stroke="#3BA7E4"
                                                        strokeWidth="1.5"
                                                        strokeMiterlimit="10"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        opacity="0.4"
                                                        d="M6.70508 7.5V11.355C6.70508 11.955 7.36508 12.3075 7.86758 11.985L8.57258 11.52C8.82758 11.355 9.15008 11.355 9.39758 11.52L10.0651 11.97C10.5601 12.3 11.2276 11.9475 11.2276 11.3475V7.5H6.70508Z"
                                                        stroke="#3BA7E4"
                                                        strokeWidth="1.5"
                                                        strokeMiterlimit="10"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </div>
                                        </div>
                                        <div className="row-2">
                                            <div className="count">
                                                <button
                                                    className="count-btn plus"
                                                    aria-label="Increase by one"
                                                    onClick={() =>
                                                        increaseHandler(item)
                                                    }
                                                >
                                                    <svg
                                                        width="15"
                                                        height="15"
                                                        viewBox="0 0 15 15"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M7.5 1L7.5 14"
                                                            stroke="#0085FF"
                                                            strokeLinecap="round"
                                                        />
                                                        <path
                                                            d="M14 7.5L1 7.5"
                                                            stroke="#0085FF"
                                                            strokeLinecap="round"
                                                        />
                                                    </svg>
                                                </button>
                                                <span className="num number dim">
                                                    {item.num}
                                                </span>
                                                <button
                                                    onClick={() =>
                                                        item.num > 0 &&
                                                        decreaseHandler(item)
                                                    }
                                                    className="count-btn"
                                                    aria-label="Decrease by one"
                                                >
                                                    <svg
                                                        width="15"
                                                        height="1"
                                                        viewBox="0 0 15 1"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M14 0.5L1 0.5"
                                                            stroke="#0085FF"
                                                            strokeLinecap="round"
                                                        />
                                                    </svg>
                                                </button>
                                            </div>
                                            <div className="inventory">
                                                <svg
                                                    width="22"
                                                    height="22"
                                                    viewBox="0 0 22 22"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M10.9999 4.58325L6.92992 1.83325L1.83325 5.49992L5.90325 8.24992L10.9999 4.58325Z"
                                                        stroke="black"
                                                        strokeWidth="1.5"
                                                        strokeMiterlimit="10"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M11 4.58325L15.07 1.83325L20.1667 5.49992L16.0967 8.24992L11 4.58325Z"
                                                        stroke="black"
                                                        strokeWidth="1.5"
                                                        strokeMiterlimit="10"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M10.9999 12.8334L6.92992 15.5834L1.83325 11.9167L5.90325 9.16675L10.9999 12.8334Z"
                                                        stroke="black"
                                                        strokeWidth="1.5"
                                                        strokeMiterlimit="10"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M11 12.8334L15.07 15.5834L20.1667 11.9167L16.0967 9.16675L11 12.8334Z"
                                                        stroke="black"
                                                        strokeWidth="1.5"
                                                        strokeMiterlimit="10"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        opacity="0.4"
                                                        d="M17.4166 14.2083V17.2057L11.3849 19.9924C11.1374 20.1024 10.8624 20.1024 10.6149 19.9924L4.58325 17.2057V14.2083"
                                                        stroke="black"
                                                        strokeWidth="1.5"
                                                        strokeMiterlimit="10"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                                <span>موجودی:</span>
                                                <span className="inv-num">
                                                    {item.inventory}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="d-flex-center pro-row">
                                            <div className="d-flex-center">
                                                <div className="price-blue min-w-160">
                                                    <svg
                                                        width="21"
                                                        height="21"
                                                        viewBox="0 0 21 21"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <g opacity="0.4">
                                                            <path
                                                                d="M7.4375 12.4688C7.4375 14.1487 8.82 15.5312 10.5 15.5312C12.18 15.5312 13.5625 14.1487 13.5625 12.4688"
                                                                stroke="#0085FF"
                                                                strokeWidth="1.5"
                                                                strokeMiterlimit="10"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                            <path
                                                                d="M7.70827 1.75L4.54077 4.92625"
                                                                stroke="#0085FF"
                                                                strokeWidth="1.5"
                                                                strokeMiterlimit="10"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                            <path
                                                                d="M13.2908 1.75L16.4583 4.92625"
                                                                stroke="#0085FF"
                                                                strokeWidth="1.5"
                                                                strokeMiterlimit="10"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </g>
                                                        <path
                                                            d="M1.75 6.86865C1.75 5.2499 2.61625 5.11865 3.6925 5.11865H17.3075C18.3838 5.11865 19.25 5.2499 19.25 6.86865C19.25 8.7499 18.3838 8.61865 17.3075 8.61865H3.6925C2.61625 8.61865 1.75 8.7499 1.75 6.86865Z"
                                                            stroke="#0085FF"
                                                            strokeWidth="1.5"
                                                        />
                                                        <path
                                                            d="M3.0625 8.75L4.29625 16.31C4.57625 18.0075 5.25 19.25 7.7525 19.25H13.0288C15.75 19.25 16.1525 18.06 16.4675 16.415L17.9375 8.75"
                                                            stroke="#0085FF"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                        />
                                                    </svg>
                                                    <span className="price-n">
                                                        {Number(
                                                            item.unit_price *
                                                                item.num
                                                        ).toLocaleString()}
                                                    </span>
                                                    <span>تومان</span>
                                                </div>
                                                {item.discount_percent
                                                    ? item.discount_percent !==
                                                          0 && (
                                                          <span className="discount">
                                                              {
                                                                  item.discount_percent
                                                              }
                                                              %
                                                          </span>
                                                      )
                                                    : ""}
                                            </div>
                                            <CopyToClipboard
                                                text={
                                                    "https://my.payacom.com/panel/product/" +
                                                    item.company_id +
                                                    "/" +
                                                    item.id
                                                }
                                            >
                                                <svg
                                                    className="mt-10"
                                                    width="48"
                                                    height="28"
                                                    viewBox="0 0 48 28"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    onClick={() => {
                                                        copyHandler(item);
                                                    }}
                                                >
                                                    <rect
                                                        width="48"
                                                        height="28"
                                                        rx="14"
                                                        fill="#CCEDFF"
                                                    />
                                                    <path
                                                        d="M28.96 8.16992C30.96 9.55992 32.34 11.7699 32.62 14.3199"
                                                        stroke="#3BA7E4"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M15.49 14.37C15.75 11.83 17.11 9.61997 19.09 8.21997"
                                                        stroke="#3BA7E4"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M20.1899 22.9399C21.3499 23.5299 22.6699 23.8599 24.0599 23.8599C25.3999 23.8599 26.6599 23.5599 27.7899 23.0099"
                                                        stroke="#3BA7E4"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M21.28 6.91989C21.28 8.44989 22.52 9.69989 24.06 9.69989C25.6 9.69989 26.84 8.45989 26.84 6.91989C26.84 5.37989 25.6 4.13989 24.06 4.13989"
                                                        stroke="#3BA7E4"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M16.83 21.9201C18.3654 21.9201 19.61 20.6755 19.61 19.1401C19.61 17.6048 18.3654 16.3601 16.83 16.3601C15.2947 16.3601 14.05 17.6048 14.05 19.1401C14.05 20.6755 15.2947 21.9201 16.83 21.9201Z"
                                                        stroke="#3BA7E4"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M33.9399 19.1401C33.9399 17.6101 32.6999 16.3601 31.1599 16.3601C29.6199 16.3601 28.3799 17.6001 28.3799 19.1401C28.3799 20.6801 29.6199 21.9201 31.1599 21.9201"
                                                        stroke="#3BA7E4"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </CopyToClipboard>
                                        </div>
                                        {item.description && (
                                            <div className="info-div">
                                                <svg
                                                    onClick={() => {
                                                        setDescription(
                                                            item.description
                                                        );
                                                        setShowDescription(
                                                            true
                                                        );
                                                    }}
                                                    width="25"
                                                    height="25"
                                                    viewBox="0 0 25 25"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M12.4999 22.9166C18.2291 22.9166 22.9166 18.2291 22.9166 12.4999C22.9166 6.77075 18.2291 2.08325 12.4999 2.08325C6.77075 2.08325 2.08325 6.77075 2.08325 12.4999C2.08325 18.2291 6.77075 22.9166 12.4999 22.9166Z"
                                                        stroke="#FF9A51"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        opacity="0.6"
                                                        d="M12.5 8.33325V13.5416"
                                                        stroke="#FF9A51"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        opacity="0.6"
                                                        d="M12.4944 16.6667H12.5037"
                                                        stroke="#FF9A51"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                    </InfiniteScroll>

                    <div className=" mt-4"></div>
                    {cartLoading ? (
                        <div className="add-to-cart">
                            <div className="mx-auto d-flex justify-content-center">
                                <img
                                    src="/assets/images/loading.gif"
                                    width={20}
                                />
                            </div>
                        </div>
                    ) : (
                        <div onClick={addToCartHandler} className="add-to-cart">
                            افزودن به سبد خرید
                        </div>
                    )}
                    <Menu active="shop" />
                </div>
            ) : (
                <div className="emp-main">
                    <svg
                        width="145"
                        height="145"
                        viewBox="0 0 145 145"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M50.8847 124.568C61.4915 130.134 66.7949 132.917 72.5 132.917V72.5006L15.9381 42.7312C15.8548 42.8651 15.773 43.0002 15.6927 43.1367C12.0834 49.2659 12.0834 56.893 12.0834 72.1472V72.854C12.0834 88.108 12.0834 95.7356 15.6927 101.865C19.3019 107.994 25.8018 111.405 38.8014 118.227L50.8847 124.568Z"
                            fill="#3BA7E4"
                        />
                        <path
                            opacity="0.7"
                            d="M106.197 26.7737L94.1135 20.4327C83.5068 14.8665 78.2034 12.0833 72.4982 12.0833C66.7931 12.0833 61.4897 14.8665 50.8828 20.4327L38.7995 26.7737C26.0892 33.4437 19.5926 36.8531 15.9362 42.7305L72.4982 72.5L129.06 42.7305C125.403 36.8531 118.907 33.4437 106.197 26.7737Z"
                            fill="#3BA7E4"
                        />
                        <path
                            opacity="0.5"
                            d="M129.307 43.1367C129.227 43.0002 129.145 42.8651 129.062 42.7312L72.5 72.5006V132.917C78.2051 132.917 83.5085 130.134 94.1153 124.568L106.199 118.227C119.198 111.405 125.698 107.994 129.307 101.865C132.917 95.7356 132.917 88.108 132.917 72.854V72.1472C132.917 56.893 132.917 49.2659 129.307 43.1367Z"
                            fill="#3BA7E4"
                        />
                        <path
                            d="M38.2036 27.0897C38.4019 26.9856 38.6018 26.8807 38.8033 26.7749L47.8267 22.0397L102.81 52.2808L127.12 40.1258C127.952 41.0679 128.675 42.0605 129.309 43.1371C130.213 44.6718 130.89 46.3004 131.398 48.1191L107.241 60.1975V78.5429C107.241 81.0453 105.213 83.0741 102.71 83.0741C100.208 83.0741 98.1789 81.0453 98.1789 78.5429V64.7286L77.0331 75.3015V132.338C75.481 132.725 74.0056 132.918 72.5019 132.918C70.9987 132.918 69.5227 132.725 67.9706 132.338V75.3015L13.6056 48.1191C14.1135 46.3004 14.7908 44.6718 15.6946 43.1371C16.3285 42.0605 17.0516 41.0679 17.8835 40.1258L72.5019 67.4352L92.9602 57.2059L38.2036 27.0897Z"
                            fill="#3BA7E4"
                        />
                        <path
                            d="M126.869 95.7335C126.265 95.0689 125.6 94.404 124.875 93.8602C120.646 90.1748 115.208 88 109.167 88C104.877 88 100.829 89.148 97.3249 91.1418C96.177 91.746 95.0896 92.4709 94.0625 93.3167C88.5042 97.7271 85 104.554 85 112.167C85 116.698 86.2689 120.987 88.5043 124.612C89.048 125.579 89.7126 126.485 90.4376 127.331C90.5585 127.513 90.7394 127.633 90.8602 127.815C95.2102 133.011 101.796 136.333 109.167 136.333C115.269 136.333 120.827 134.098 125.056 130.292C125.298 130.11 125.479 129.929 125.66 129.688C127.292 128.298 128.681 126.546 129.829 124.612C132.064 120.987 133.333 116.698 133.333 112.167C133.333 105.823 130.856 100.084 126.869 95.7335ZM118.229 116.577H113.698V121.29C113.698 123.767 111.644 125.821 109.167 125.821C106.69 125.821 104.635 123.767 104.635 121.29V116.577H100.104C97.6271 116.577 95.5729 114.523 95.5729 112.046C95.5729 109.569 97.6271 107.514 100.104 107.514H104.635V103.225C104.635 100.748 106.69 98.6939 109.167 98.6939C111.644 98.6939 113.698 100.748 113.698 103.225V107.514H118.229C120.706 107.514 122.76 109.569 122.76 112.046C122.76 114.523 120.706 116.577 118.229 116.577Z"
                            fill="#3BA7E4"
                        />
                    </svg>

                    <p className="emp-text">کالایی ثبت نشده است</p>
                </div>
            )}
        </div>
    );
};

export default BrandProducts;
